
import HeightTween from 'vue-height-tween-transition'
import Visual from 'vue-visual'
export default

	components: { HeightTween, Visual }

	props:
		title: String # The title of the pane
		open: Boolean
		uncloseable: Boolean # Prevent manually closing

		# The type of the toggle icon
		toggleIcon:
			type: String
			default: "Plus/Minus"
			validator: (val) -> val in ["Plus/Minus", "Arrow", "Chevron"]

		# Compact layout has overall smaller size
		layout:
			type: String
			default: "Normal"
			validator: (val) -> val in ["Compact", "Normal"]


	# Store our own pane state, so this can be used in isolation or as part of
	# an accordion where only one is open at a time
	data: -> isOpen: @open

	computed:

		# Make the icon to show in the button
		icon: -> if @isOpen then '—' else '+'

		# Disable the pane it is uncloseable and open
		disabled: -> ( @uncloseable && @isOpen )

		# Classses for the pane
		classes: -> [
			if @disabled then 'disabled'
			if @togglIcon == 'Arrow' then 'arrow'
			@layout.toLowerCase()
			if @isOpen then 'open'
		]

	watch:

		# Sync the open state
		open: -> @isOpen = @open

		# Even events when it's opened / clsoed
		isOpen: ->
			if @isOpen then @$emit 'open' else @$emit 'close'
			@$emit 'toggle', @isOpen

	methods:

		# Handle toggle clicks
		onToggle: ->
			return if @uncloseable and @isOpen
			@isOpen = !@isOpen

		afterEnter: ->
			update = =>
				@$ScrollTrigger?.refresh()
				@$scroller.update()

			setTimeout update, 600

